export default "__VITE_ASSET__CWoEbG7m__"